import { TLNRChampion } from '../models'

export const getInitialLnRChampionForm = (): TLNRChampion => ({
  EntryId: 0,
  Email: '',
  FirstName: '',
  JobTitle: '',
  LastName: '',
  MobilePhone: '',
  MobilePhone_Prefix: '',
  RequestId: 0,
  WorkPhone: '',
  WorkPhone_Prefix: '',
})
